<template>
  <div class="auth-in-root">
    <loader-rotate-bounce />
  </div>
</template>

<script>

import { mapActions } from 'vuex'
import LoaderCycle from '../../components/Loaders/LoaderCycle'
import LoaderRotateBounce from '../../components/Loaders/LoaderRotateBounce'

export default {
  name: 'AuthIn',
  components: { LoaderRotateBounce, LoaderCycle },
  created() {
    this.handleSsoSignIn(this.$route.query.code)
  },
  computed: {
    language() {
      return this.$store.getters.language
    },
  },
  methods: {
    ...mapActions(['SsoLoginVendor']),

    handleSsoSignIn(code){
      const that = this;
      this.SsoLoginVendor({
        ssoCode: code,
        ssoType: '2'
      }).then(res => {
        const { success, result, message } = res || {};
        // const { userInfo } = result || {};
        if(success){
          this.$router.push({ path: "/dashboard/analysis" })
          that.$notification.success({
            message: this.language['portal.ui2.loginSuccess'], // '登錄成功',
            description: this.language['system.loginWelcomeMessage'] // '您好！歡迎回來.',
          });
        }else{
          this.$notification.error({
            message: this.language['portal.ui2.icivetAuthFail'],
            description: message,
            duration: 4
          });
          this.$router.push('/user/login')
        }
      }).catch(err => {
        const { message } = err || {}
        this.$message.error(message)
        this.$router.push('/user/login')
      }).finally(()=>{

      })
    }
  }
}
</script>

<style lang="less" scoped>
.auth-in-root{
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
}

// IE10+ CSS here
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .auth-in-root{
    min-height: 1200px;
  }
}
</style>